import { call, put, takeLatest } from 'redux-saga/effects';

import { UpdateMaskParams } from 'types';
import { YieldOf } from 'types/utils';

import { updateMask, updatedMask } from './actions';
import { fetchMasks } from '../masks/actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type UpdateMaskActionPayload = ReturnType<typeof updateMask>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function buildFormData(formData: FormData, data: any, parentKey?: string) {
  // Here we need to enter in nested objects to append the key as object.key=value
  // However we do not want to enter in the uploaded files which are appended as a whole
  if (data && typeof data === 'object' && !(data instanceof File)) {
    // Handle arrays specifically
    if (Array.isArray(data)) {
      data.forEach((item, index) => {
        const key = parentKey ? `${parentKey}[${index}]` : `[${index}]`;
        buildFormData(formData, item, key);
      });
    }
    // Handle regular objects
    else {
      Object.keys(data).forEach((key) => {
        const nestedKey = parentKey ? `${parentKey}.${key}` : key;
        buildFormData(formData, data[key as keyof UpdateMaskParams], nestedKey);
      });
    }
  } else if (parentKey) {
    if (data instanceof File) {
      formData.append(parentKey, data);
    } else if (data != null) {
      // Only append non-null values
      formData.append(parentKey, data.toString());
    }
  }
}

function jsonToFormData(data: UpdateMaskParams): FormData {
  const formData = new FormData();

  buildFormData(formData, data, undefined);

  return formData;
}

export function* updateMaskSaga({ meta: { mask, callback } }: UpdateMaskActionPayload) {
  const { updateMaskApi } = getAPI();
  const response: YieldOf<typeof updateMaskApi> = yield call(updateMaskApi, jsonToFormData(mask));
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchMasks());
    yield put(updatedMask(data));
    if (callback) yield call(callback);
  } else {
    const error = problem || 'unknown';
    yield put(updatedMask(undefined, error));
  }
}

export default function* MaskSaga() {
  yield takeLatest(updateMask.type, updateMaskSaga);
}
